<template lang="pug">

  .contenedor-datos
    .title
      span.little Datos personales para consulta
      span.icon.close(@click="$emit('close')")
        i.fa.fa-close
    template(v-if="isLoading")
      loading
    template(v-else)
      datos-conjuntos(:model="empleado.codigo", title="Codigo interno")
      datos-conjuntos(:model="empleado.dni", title="DNI")
      datos-conjuntos(:model="empleado.cargo", title="Cargo")
      datos-conjuntos(:model="empleado.email", title="Email de la empresa")
      datos-conjuntos(:model="empleado.fechaIngreso", title="Fecha de ingreso")

      datos-conjuntos(
        :model="`${empleadoPersonal.sueldoCuenta} ${empleadoPersonal.sueldoNombreBanco} ${empleadoPersonal.sueldoMoneda}`",
        title="Cuenta Sueldo",
        dangerMessage="Recursos humanos debe especificar el dato"
      )

      datos-conjuntos(
        :model="`${empleadoPersonal.ctsCuenta} ${empleadoPersonal.ctsNombreBanco} ${empleadoPersonal.ctsMoneda}`",
        title="Cuenta CTS",
        dangerMessage="Recursos humanos debe especificar el dato"
      )

      datos-conjuntos(
        :model="empleadoPersonal.tipoPension",
        title="Tipo pension",
        dangerMessage="Recursos humanos debe especificar el dato"
      )

      datos-conjuntos(
        :model="empleado.regimen",
        title="Régimen",
        capitalize=true,
        dangerMessage="General"
      )
</template>

<script>
import { apiGet, notify } from '../util/general'
import DatosConjunto from './Component_Datos_Conjuntos'

export default {
  name: 'datos_personales_consulta_component',
  components: {
    'datos-conjuntos':DatosConjunto
  },
  data () {
    return {
      empleado: {},
      empleadoPersonal: {},
      isLoading: true
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/personal/empleado', obj, function (data) {
        data.empleado.codigo = data.empleado.codigo.toString();
        data.empleado.dni = data.empleado.dni.toString();
        vm.empleado = data.empleado
        vm.empleadoPersonal = data.empleadoPersonal
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .contenedor-datos
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
        i
          position absolute
          top 5px
          right: 5px
      .little
        font-size 14px

  .conjunto-datos
    display flex
    text-align left
    flex-direction column
    .danger
      color red
    .body
      background-color #f8f9fa
      border-radius 5px
      padding 10px
      margin-bottom 10px

  DatosConjunto
    .body
      .title
        font-size: 1.1rem
</style>



// WEBPACK FOOTER //
// Component_Datos_Personales_Consulta.vue?3bddbc5f